import { NgStyle } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Popover } from '@ntv360/component-pantry';
import { TableActionService } from './table-actions.service';

@Component({
    selector: 'app-table-actions',
    standalone: true,
    imports: [Popover, NgStyle],
    templateUrl: './table-actions.component.html',
    styleUrl: './table-actions.component.scss',
})
export class TableActionsComponent {
    /**
     * Service reference since emit function don't work with ngTemplate context, the app table can't reach the emitted event
     */
    private _tableActionService = inject(TableActionService);
    /**
     * The rest of table actions, hidden in a popover.
     */
    public actions = input<
        { name: string; icon: string; color: string; hightlighLabel?: boolean }[]
    >([]);

    /**
     * Row input data from app table
     */
    public rowData = input<any>();

    /**
     * Handles the click event for table actions
     * @param name The name of the action
     */
    protected handleTableAction(name: string): void {
        if (name) {
            this._tableActionService.emit(name, this.rowData());
        }
    }
}
